// NOTE: if we trigger a download via window.location, safari (15.2, and maybe a little earlier) will interupt any outgoing calls
// in cases of things like checking out an asset, we refetch the asset at the same time we are triggering the download - the `getAssetBean`
// call is interupted and the fetch never goes through (in fact throws a generic error because the call was not resolved)

/**
 * Will trigger a download in the borwser for the provided link
 * @param link Link to download
 *
 * @example
 * ```ts
 * openDownloadLink('https://example.com/file.zip');
 * ```
 */
export const openDownloadLink = (link: string, name?: string) => {
	// Safari (at least v15.2) ¯\_(ツ)_/¯
	// window.location = link;
	const anchor = document.createElement('a');
	anchor.setAttribute('download', name ?? '');
	anchor.href = link;
	document.body.appendChild(anchor);
	anchor.click();
	anchor.remove();
};

export default openDownloadLink;
